import { AnalyticsApi } from '@/../generated-client/apis/AnalyticsApi';
import { useApiStore } from '@/stores/apiStore';

let analyticsApi: AnalyticsApi | null = null;
let lastConfig: unknown = null;

function getAnalyticsApi(): AnalyticsApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (analyticsApi === null || lastConfig !== apiConfig) {
    analyticsApi = new AnalyticsApi(apiConfig);
    lastConfig = apiConfig;
  }

  return analyticsApi;
}

export const getActiveUsersByOrg = async () => {
  const api = getAnalyticsApi();
  return await api.apiAnalyticsGetActiveUsersByOrgGet();
};

export const getCompassDeviceUseByOrg = async () => {
  const api = getAnalyticsApi();
  return await api.apiAnalyticsGetCompassDeviceUseByOrgGet();
};

export const getEmergenciesByOrg = async () => {
  const api = getAnalyticsApi();
  return await api.apiAnalyticsGetEmergenciesByOrgGet();
};
